import { v4 as uuidv4 } from 'uuid';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { FlexLayoutRow, FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function TipbarGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'TipbarGroup',
		props: VisibilityLayout({ mzTitle: 'MZ | Informações de destaque (On/Off)' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{ blockClass: 'tipbar-group-1', preserveLayoutOnMobile: true, mzTitle: 'MZ | Informações de destaque' },
				[
					VisibilityLayout({ mzTitle: 'MZ | Coluna 1 (On/Off)' }, [
						FlexLayoutCol(
							{
								mzTitle: 'MZ | Destaque - Coluna 1',
								preventVerticalStretch: true,
								blockClass: 'tipbar-group-1',
							},
							[
								Image({
									src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060697082-deals-icon-01---2c612c2e108859512614c2a6f28d25a8.png',
									maxHeight: '40px',
								}),
								RichText({
									text: 'Diferencial de compra tip bar 1',
									blockClass: 'tipbar-group-1',
								}),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Coluna 2 (On/Off)' }, [
						FlexLayoutCol(
							{
								mzTitle: 'MZ | Destaque - Coluna 2',
								preventVerticalStretch: true,
								blockClass: 'tipbar-group-1',
							},
							[
								Image({
									src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060697082-deals-icon-01---2c612c2e108859512614c2a6f28d25a8.png',
									maxHeight: '40px',
								}),
								RichText({
									text: 'Diferencial de compra tip bar 2',
									blockClass: 'tipbar-group-1',
								}),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Coluna 3 (On/Off)' }, [
						FlexLayoutCol(
							{
								mzTitle: 'MZ | Destaque - Coluna 3',
								preventVerticalStretch: true,
								blockClass: 'tipbar-group-1',
							},
							[
								Image({
									src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060697082-deals-icon-01---2c612c2e108859512614c2a6f28d25a8.png',
									maxHeight: '40px',
								}),
								RichText({
									text: 'Diferencial de compra tip bar 3',
									blockClass: 'tipbar-group-1',
								}),
							],
						),
					]),
					VisibilityLayout({ mzTitle: 'MZ | Coluna 4 (On/Off)' }, [
						FlexLayoutCol(
							{
								mzTitle: 'MZ | Destaque - Coluna 4',
								preventVerticalStretch: true,
								blockClass: 'tipbar-group-1',
							},
							[
								Image({
									src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060697082-deals-icon-01---2c612c2e108859512614c2a6f28d25a8.png',
									maxHeight: '40px',
								}),
								RichText({
									text: 'Diferencial de compra [saiba mais](https://stackedit.io/app#)',
									blockClass: 'tipbar-group-1',
								}),
							],
						),
					]),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--tg-1-background', name: 'Background' },
			{ from: '--text-color-1', to: '--tg-1-text-color', name: 'Text' },
		],
	},
	{
		type: 'fontSize',
		list: [{ from: '--font-size-sm', to: '--tg-1-text-fs', name: 'Text' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--tg-1-ff', name: 'Font Family' }],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-nano', to: '--tg-1-inside-gap', name: 'Espaço entre a foto e o texto' }],
	},
];
